import React, { useState, useEffect, useRef } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import uuid from 'react-uuid';
import { Formik } from 'formik';
import RelativeForm from './RelativeForm';
import WarningNotiifcation from 'components/WarningNotification';
import ReCAPTCHA from 'react-google-recaptcha';
import { SetLoading } from "redux/actions/loadingActions";
import { connect } from 'react-redux';
import { updateMany } from 'services';
import InputMask from "react-input-mask";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { SetOperationSuccess  } from "redux/actions/operationSuccessActions";
import { SetHasFamilyStructure } from "redux/actions/hasFamilyStructureDataActions"; 
import Spinner from 'react-bootstrap/Spinner';
import { useHistory } from "react-router";

let yup = require('yup');

const notify = (text) => toast.warn(text, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
});

const RelativeFormWrapper = ({data, user, SetLoading, SetOperationSuccess, opeationSuccess, SetHasFamilyStructure, hasFamilyStructureDataReducer}) => {
    const [reCAPTCHA, setReCAPTCHA] = useState('');
    const reRef = useRef();
    const [relativeForms, setRelativeForms] = useState([]);
    const [exampleOptionsArray, setExampleOptionsArray] = useState([]);
    const [loadForm, setLoadForm] = useState(false);
    const [formContent, setFormContent] = useState({});
    const [formikSchema, setFormikSchema] = useState({});
    const [basicSchema, setBasicSchema] = useState({});
    const [saveAndContinue, setSaveAndContinue] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const formRef = useRef();
    const history = useHistory();

    useEffect(() => {
        setExampleOptionsArray(() => {
            return [{ value: 1, label: 'option 1' }, { value: 2, label: 'option 2' }]
        });

        if (data && data.length > 0) {
            user.persona.personaFamilias = data;

            let schema = {};
            let values = {};
            let list = [];

            data.forEach(element => {
                const elementId = element.id;
                let compoundDate = null;
                let birthDate = new Date();

               schema = {
                ...schema,
                [`names_${elementId}`]: yup.string().required("El campo es requerido"),
                [`lastNames_${elementId}`]: yup.string().required("El campo es requerido"),
                [`birthDate_${elementId}`]: yup.string().test('len', 'Must be exactly 10 characters', val => val.toString().replaceAll('_', '').length === 10).required("El campo es requerido"),
                [`kinship_${elementId}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
                [`profession_${elementId}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
                [`direction_${elementId}`]: yup.string().required("El campo es requerido"),
               };

               if (element.fechaNacimiento && element.fechaNacimiento != '0001-01-01T00:00:00') {
                    birthDate = new Date(element.fechaNacimiento);
                    const day = birthDate.getDate();
                    const month = birthDate.getMonth() + 1;
                    const year = birthDate.getFullYear();
                    compoundDate = `${day <= 9 ? '0'+ day : day }/${month <= 9 ? '0'+ month : month}/${year}`;
                }

               values = {
                ...values,
                [`names_${elementId}`]: element.nombre,
                [`lastNames_${elementId}`]: element.apellido,
                [`birthDate_${elementId}`]: compoundDate,
                [`kinship_${elementId}`]: element.parentescoId,
                [`profession_${elementId}`]: element.profesionId,
                [`direction_${elementId}`]: element.direccion,
               };

               list.push({
                id: elementId,
                estado: element.estado,
                isNew: false,
            })
            });
        
            updateFormik(schema);

            setFormContent(() => {
                return values
            });

            setRelativeForms(() => {
                return [
                    ...list
                ];
            });
        }
        setLoadForm(true);
    }, [data])
    

    useEffect(() => {
        if (loadForm) {
            if (data && data.length == 0) {
                onAddRelativeForm();
            }
        }
    }, [loadForm]);

    const updateFormik = (schema) => setFormikSchema(() => {
        return yup.object(schema);
    });

    const onSaveAndContinue = () => {
        formRef.current.validateForm().then(data => {
            if (Object.keys(data).length === 0 && data.constructor === Object) {
                setSaveAndContinue(true);
                formRef.current.handleSubmit();
            }
        })
    }

    const onSave = () => {
        formRef.current.validateForm().then(data => {
            if (Object.keys(data).length === 0 && data.constructor === Object) {
                setSaveAndContinue(false);
                formRef.current.handleSubmit();
            }
        })
    }

    const onExit = () => {
        history.push({
            pathname: "/familyStructure",
            state: {
                updateUserData: true
            }
        });
    }

    const onAddRelativeForm = () => {
        const guid = uuid();
        const oldValues = formRef.current.values;

        const newSchema = {
            ...basicSchema,
            [`names_${guid}`]: yup.string().required("El campo es requerido"),
            [`lastNames_${guid}`]: yup.string().required("El campo es requerido"),
            [`birthDate_${guid}`]: yup.string().test('len', 'Must be exactly 10 characters', val => val.toString().replaceAll('_', '').length === 10).required("El campo es requerido"),
            [`kinship_${guid}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
            [`profession_${guid}`]: yup.number().typeError("El campo es numérico").required("El campo es requerido"),
            [`direction_${guid}`]: yup.string().required("El campo es requerido"),
        };

        setBasicSchema(() => {
            return newSchema;
        });
        
        setFormContent(() => {
            return {
                ...oldValues,
                [`names_${guid}`]: '',
                [`lastNames_${guid}`]: '',
                [`birthDate_${guid}`]: null,
                [`kinship_${guid}`]: 1,
                [`profession_${guid}`]: 1,
                [`direction_${guid}`]: '',
            }
        });
        
        setRelativeForms(() => {
            return [
                ...relativeForms,
                {
                    id: guid,
                    estado: 1,
                    isNew: true,
                }
            ];
        });
        
        updateFormik(newSchema);
    };

    const onRemoveRelativeForm = (identifier) => {
        let newSchema = basicSchema;
        const oldValues = formRef.current.values;
        const removedForm = relativeForms.find(x => x.id === identifier);

        const schemaKeys = [`names_${identifier}`, 
            `lastNames_${identifier}`, 
            `birthDate_${identifier}`, 
            `kinship_${identifier}`, 
            `profession_${identifier}`, 
            `direction_${identifier}`,
        ];

        schemaKeys.forEach(key => {
            delete newSchema[key]
            delete oldValues[key]
        });

        setBasicSchema(() => {
            return newSchema;
        });

        setFormContent(() => {
            return oldValues
        });
        
        updateFormik(newSchema);

        if (removedForm.isNew) {
            setRelativeForms(() => {
                return [
                    ...relativeForms.filter(x => x.id !== identifier)
                ]
            })
        } else {
            removedForm.estado = 0;
            setRelativeForms(() => {
                return [
                    ...relativeForms
                ]
            })
        }
    };

    const onFormSubmitted = async (form) => {
        try {
            
            let List = [];
            
            for (let index = 0; index < relativeForms.length; index++) {
                const relative = relativeForms[index];
                //relativeForms.forEach(relative => {

                if (relative.estado !== 0 && (Number(form['birthDate_' + relative.id].substring(0,2)) > 31 || Number(form['birthDate_' + relative.id].substring(3,5)) > 12 || Number(form['birthDate_' + relative.id].substring(6,10)) > new Date().getFullYear())) {
                    if (Number(form['birthDate_' + relative.id].substring(0,2)) > 31) 
                        notify('El día ingresado en la fecha de nacimiento de '+ form['names_' + relative.id] + ' ' + form['lastNames_' + relative.id] + ' no es válido');
                    if (Number(form['birthDate_' + relative.id].substring(3,5)) > 12) 
                        notify('El mes ingresado en la fecha de nacimiento de '+ form['names_' + relative.id] + ' ' + form['lastNames_' + relative.id] +' no es válido');
                    if (Number(form['birthDate_' + relative.id].substring(6,10)) > new Date().getFullYear()) 
                        notify('El año ingresado en la fecha de nacimiento de '+ form['names_' + relative.id] + ' ' + form['lastNames_' + relative.id] +' no es válido');
                    return;
                }

                const nombre = (relative.estado === 0)
                ? user.persona.personaFamilias.find(x => x.id === relative.id)?.nombre
                : form['names_' + relative.id];
                
                const apellido = (relative.estado === 0)
                ? user.persona.personaFamilias.find(x => x.id === relative.id)?.apellido
                : form['lastNames_' + relative.id];

                let fechaNacimiento = null;
                
                if (relative.estado === 0) {
                    const personaFamiliaSavedDate = user.persona.personaFamilias.find(x => x.id === relative.id)?.fechaNacimiento;
                    const birthDateFormat = new Date(personaFamiliaSavedDate);
                    fechaNacimiento = birthDateFormat;
                } else {
                    const mm_dd_yyyy_format = `${form['birthDate_' + relative.id].substring(3,5)}/${form['birthDate_' + relative.id].substring(0,2)}/${form['birthDate_' + relative.id].substring(6,10)}`
                    const birthDateFormat = new Date(mm_dd_yyyy_format);
                    fechaNacimiento = birthDateFormat;
                }

                const parentescoId = (relative.estado === 0)
                ? parseInt( user.persona.personaFamilias.find(x => x.id === relative.id)?.parentescoId)
                : parseInt(form['kinship_' + relative.id]);

                const profesionId = (relative.estado === 0)
                ? parseInt( user.persona.personaFamilias.find(x => x.id === relative.id)?.profesionId)
                : parseInt(form['profession_' + relative.id]);

                const direccion = (relative.estado === 0)
                ? user.persona.personaFamilias.find(x => x.id === relative.id)?.direccion
                : form['direction_' + relative.id];

                const personaFamilia = {
                    id: relative.isNew ? null : relative.id,
                    personaId: user.persona.id,
                    estado: relative.estado,
                    nombre,
                    apellido,
                    fechaNacimiento,
                    parentescoId,
                    profesionId,
                    direccion
                }
                List.push(personaFamilia);
            }

            setIsLoading(true);

            const response = await updateMany('PersonaFamilia', List/*, reCAPTCHA*/);
            
            if (response && response.data && response.data.some(x => x.estado == 1)) {
                SetHasFamilyStructure(true);
            } else {
                SetHasFamilyStructure(false);
            }

            setIsLoading(false);

            SetOperationSuccess(opeationSuccess +1);
            const route = saveAndContinue ? "/vehicle" : "/familyStructure";
            history.push({
                pathname: route,
                state: {
                    updateUserData: true
                }
            });


        } catch (error) {
            console.log(error)
        } finally {
            SetLoading(false);
            setReCAPTCHA('');
        }
    };

    return (
        <>
            {
                isLoading &&
                <div className={'display-flex flex-direction-row flex-center'}>
                    <Spinner 
                        animation="grow" 
                        variant="primary" 
                        className={'is-absolute center-spinner-vertically'} 
                        size="lg" />
                </div>
            }
            <Card>
                <Card.Body className={'p-40'}>
                    {
                        loadForm &&
                        <div>
                            <Formik
                                innerRef={formRef}
                                validationSchema={formikSchema}
                                onSubmit={onFormSubmitted}
                                initialValues={formContent}
                                enableReinitialize={true}
                                validateOnChange={false}
                                validateOnBlur={false}
                            >
                                {({
                                    handleSubmit,
                                    handleChange,
                                    handleBlur,
                                    values,
                                    touched,
                                    isValid,
                                    errors,
                                    setFieldValue
                                }) => (
                                    <Form noValidate onSubmit={handleSubmit}>

                                        <Form.Row>
                                            
                                            <Form.Group 
                                                as={Col} 
                                                md="12" 
                                                controlId="campos_obligatorios"
                                                className="mb-25"
                                                style={{fontSize: 18}}>
                                                    <div>
                                                        <b> Campos obligatorios * </b>
                                                    </div>
                                            </Form.Group>

                                            {
                                                (relativeForms.length > 0 && relativeForms.filter(x => x.estado === 1).length > 0) ? 
                                                relativeForms.filter(x => x.estado === 1).map((element) => {
                                                    return <RelativeForm 
                                                        key={element.id} 
                                                        handleChange={handleChange} 
                                                        errors={errors} 
                                                        touched={touched} 
                                                        values={values} 
                                                        element={element}
                                                        removeRelativeForm={onRemoveRelativeForm}
                                                        options={exampleOptionsArray}
                                                        setFieldValue={setFieldValue}
                                                        handleBlur={handleBlur}
                                                        isValid={isValid} />
                                                })
                                                : 
                                                <Form.Group as={Col} md="12">
                                                    <WarningNotiifcation message='No ha agregado formularios a la sección ' enphasis='Estructura familiar'/>
                                                </Form.Group>
                                            }
                                            <Form.Group className={'display-flex flex-end'} as={Col} md="12">
                                                <Button onClick={onAddRelativeForm}> Agregar </Button>
                                            </Form.Group>
                                            
                                        </Form.Row>
                                        {
                                            relativeForms.length > 0 && 
                                            <Form.Group className={'display-flex space-between padding-right-0'} as={Col} md="12">
                                                {
                                                    hasFamilyStructureDataReducer 
                                                    ? <Button size="medium" variant="light" onClick={onExit}> <b> Cancelar edición </b> </Button>
                                                    : <div> </div>
                                                }
                                                <div>
                                                    <Button size="medium" type="button" onClick={onSave}> <b> Guardar </b> </Button>
                                                    <Button className={'margin-left-5'} size="medium" type="button" onClick={onSaveAndContinue}> <b> Guardar y continuar </b> </Button>
                                                </div>
                                            </Form.Group>
                                        }
                                    </Form>
                                    )}
                            </Formik>
                        </div>
                    }
                </Card.Body>
            </Card>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        opeationSuccess: state.opeationSuccess,
        hasFamilyStructureDataReducer: state.hasFamilyStructureDataReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        SetLoading: (value) => dispatch(SetLoading(value)),
        SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
        SetHasFamilyStructure: (value) => dispatch(SetHasFamilyStructure(value))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(RelativeFormWrapper);